document.addEventListener('DOMContentLoaded', function() {
  // Tüm gelişmiş slideshow öğelerini seç
  const slideshows = document.querySelectorAll('slideshow-carousel');
  
  slideshows.forEach(slideshow => {
    // Yön ok düğmelerini bul
    const prevButtons = slideshow.querySelectorAll('[data-action="prev"]');
    const nextButtons = slideshow.querySelectorAll('[data-action="next"]');
    
    // Önceki slayta geçiş için tıklama olayı ekle
    prevButtons.forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        slideshow.previous();
      });
    });
    
    // Sonraki slayta geçiş için tıklama olayı ekle
    nextButtons.forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        slideshow.next();
      });
    });
  });
});
